import * as api from "services/api";
import _ from "lodash";
import history from "../../../../history";

export const ADD_INN = "[INN ADD] ADD_INN";
export const ADD_INN_SUCCESS = "[INN ADD] ADD_INN_SUCCESS";
export const ADD_INN_FAILED = "[INN ADD] ADD_INN_FAILED";

export const SET_VALUE = "[INN ADD] SET_VALUE";
export const CLEAR_VALUE = "[INN ADD] CLEAR_VALUE";

export function addInn() {
	return async (dispatch, getState) => {
		dispatch({
			type: ADD_INN
		});

		const { login, innCreate } = getState();

		let { clientId, userId, status } = innCreate;

		const errors = {};

		if (!clientId) {
			errors.clientId = "Campo obrigatório";
		}

		dispatch(
			setValue({
				errors
			})
		);

		if (_.keys(errors).length > 0) return dispatch({ type: ADD_INN_FAILED });

		let response = await api.sendPost(
			"/Inn",
			{
				clientId,
				userId,
				status
			},
			{
				Authorization: "Bearer " + login.token
			}
		);

		const result = await response.json();

		if (result.isValid) {
			dispatch({
				type: ADD_INN_SUCCESS
			});

			dispatch(clearValue());

			await new Promise(res =>
				setTimeout(() => {
					history.push(`/inns/${result.model.id}`);
					res();
				}, 1000)
			);
		} else {
			dispatch({ type: ADD_INN_FAILED, payload: result.errors });
		}
	};
}

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function clearValue(payload) {
	return {
		type: CLEAR_VALUE,
		payload
	};
}
